import { Modal } from "react-bootstrap"

export default function AlertModal(props) {
    return (
        <Modal show={props.alertModal.ShowAlertModal} backdrop="static" keyboard={false}>
            <Modal.Body>
                <div className="row col-12 justify-content-center">
                    <div className="col-10 text-center">
                        {props.alertModal.Message}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="col-12 d-flex justify-content-sm-between justify-content-center flex-column flex-sm-row">
                    <button type="button" className="btn btn-outline-dark rounded-pill px-5 my-1 my-sm-0 mx-auto" onClick={props.handleCancelChangeLocation}>Cancel change</button>
                    <button type="button" className="btn btn-dark rounded-pill px-5 my-1 my-sm-0 mx-auto" onClick={props.handleConfirmChangeLocation}>Change location</button>                    
                </div>
            </Modal.Footer>
        </Modal>
    )
}